export default __webpack_public_path__ + "static/media/ukrainegot-screenshot-04.4c51aeb2.png";